import React from 'react';
import { useNavigate } from 'react-router-dom';

// Digital HIG Components
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";
// @ts-ignore
import DHButton from "@digital-hig/mui/Button";

interface ErrorPageProps {
  message?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ 
  message = "Something went wrong on our end. In the meantime, you can try refreshing the page or come back later." 
}) => {
  const navigate = useNavigate();

  return (
    <DHBox
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        margin: 0,
        padding: 0,
        background: 'linear-gradient(to bottom, hsla(0, 0%, 100%, 1), hsla(0, 0%, 98%, 1))',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        zIndex: 9999
      }}
    >
      {/* Red border box at 200px from top */}
      <DHBox
        sx={{
          position: 'absolute',
          top: '200px',
          left: '50%',
          transform: 'translateX(-50%)',
          paddingTop: 4,
          paddingBottom: 4,
          paddingLeft: 0,
          paddingRight: 4,
          backgroundColor: 'transparent',
          borderRadius: 1,
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
          width: '640px',
          height: '375px'
        }}
      >
        <DHBox sx={{ marginBottom: 2, marginLeft: 0, paddingLeft: 0 }}>
          <img
            src="/images/autodesk-black.png"
            alt="Autodesk Logo"
            style={{
              width: '162px',
              height: '19.31px',
              objectFit: 'contain',
              opacity: 1
            }}
          />
        </DHBox>

        {/* Blue border box inside red box, 87px from top of red box */}
        <DHBox
          sx={{
            position: 'absolute',
            top: '84.31px',
            left: 0,
            right: 0,
            padding: 0,
            backgroundColor: 'transparent',
            borderRadius: 1,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '217px'
          }}
        >
          <DHBox 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              justifyContent: 'center',
              width: '100px',
              height: '100px',
              padding: 1,
              boxSizing: 'border-box'
            }}
          >
            <img 
              src="/images/internal-error.png" 
              alt="Internal Error" 
              style={{
                width: '91px',
                height: '63px',
                objectFit: 'contain'
              }}
            />
          </DHBox>

          {/* Black box at bottom of blue box */}
          <DHBox
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: 'transparent',
              width: '100%',
              height: '93px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 2,
              boxSizing: 'border-box'
            }}
          >
            <DHTypography
              variant="headline-medium"
              sx={{
                fontFamily: 'Artifakt Legend',
                fontWeight: 800,
                fontSize: '26px',
                lineHeight: '120%',
                letterSpacing: '0%',
                color: 'var(--ink-on-background, hsla(0, 0%, 0%, 1))',
                marginLeft: 0,
                paddingLeft: 0,
                marginTop: 0,
                marginBottom: 0
              }}
            >
              Internal server error
            </DHTypography>
            <DHTypography
              variant="body-copy-medium"
              sx={{
                fontFamily: 'Artifakt Element',
                fontWeight: 400,
                fontSize: '18px',
                lineHeight: '150%',
                letterSpacing: '0%',
                color: 'var(--text-on-background, hsla(0, 0%, 13%, 1))',
                marginLeft: 0,
                paddingLeft: 0,
                marginTop: 'auto',
                marginBottom: 0
              }}
            >
              {message}
            </DHTypography>
          </DHBox>
        </DHBox>

        <DHBox
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingTop: 2,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 2,
            boxSizing: 'border-box'
          }}
        >
          <DHButton
            variant="contained"
            color="primary"
            className="dhig-button-contained dhig-button-primary"
            onClick={() => navigate('/', { replace: true })}
            sx={{
              height: 40,
              borderRadius: '4px',
              padding: '8px 20px',
              fontFamily: 'Artifakt Element, sans-serif',
              fontWeight: 600,
              fontSize: '16px',
              lineHeight: '20px',
              letterSpacing: '0%',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            Go to Login Page
          </DHButton>
        </DHBox>
      </DHBox>
    </DHBox>
  );
};

export default ErrorPage;

